import api from '../Api';

export const fetchReports = async (page = '', limit = '') => {
  const response = await api.get(`/report?page=${page}&limit=${limit}`);
  return response.data;
};

export const fetchReportById = async reportId => {
  const response = await api.get(`/report/${reportId}`);
  return response.data.report;
};

export const deleteReport = async reportId => {
  const response = await api.delete(`/report/${reportId}`);
  return response.data.report;
};

export const updateBusinessStatus = async (businessId, status) => {
  const response = await api.patch(`/admin/status/${businessId._id}/${status}`);
  return response.data;
};
